import { reactive } from 'vue';

const propertyMapData = reactive(new Map([
  ["AED", "aed"],
  ["空調設備", "air_conditioner"],
  ["集会室", "assembly_room"],
  ["地下室", "basement"],
  ["掲示板・掲示物", "board"],
  ["増圧ポンプ", "booster_pump"],
  ["汚水槽", "cesspool"],
  ["集合郵便ポスト", "collective_mailbox"],
  ["宅配ボックス", "delivery_box"],
  ["館銘板", "disposer"],
  ["分電盤", "distribution_board"],
  ["排水ポンプ", "drainage_pump"],
  ["電気工作物", "electrical_work"],
  ["高架水槽", "elevated_tank"],
  ["エレベーター", "elevator"],
  ["非常用エレベーター", "emergency_elevator"],
  ["エントランス", "entrance"],
  ["消防設備", "firefight_equipment"],
  ["平置き駐輪場", "flat_b_parking"],
  ["平置きバイク置き場", "flat_m_parking"],
  ["平置き駐車場", "flat_parking"],
  ["共用廊下", "hallway"],
  ["内廊下", "inner_corridor"],
  ["内階段", "inner_staircase"],
  ["管理室", "janitor"],
  ["キッズルーム", "kids_room"],
  ["ロッカールーム", "locker_room"],
  ["メールボックス", "mailbox"],
  ["MDF盤", "mdf_board"],
  ["機械式駐車場", "mechanical_parking"],
  ["事務所", "office"],
  ["外回り", "outer_circumference"],
  ["外階段", "outside_stairs"],
  ["植栽", "planting"],
  ["プレイロット", "play_lot"],
  ["ラック式駐輪場", "rack_b_parking"],
  ["受水槽", "receiving_tank"],
  ["屋上", "rooftop"],
  ["外構門扉、余地部等", "septic_tank"],
  ["店舗", "store"],
  ["トイレ", "toilet"],
  ["外観", "tools"],
  ["ゴミ庫", "trash"],
  ["ゴミストッカー", "trash_stocker"],
  ["自販機", "vending_machine"],
  ["排水溝、側溝", "drain"],
  ["共用部スイッチ", "common_area_switch"],
  ["エントランス扉", "entrance_door"],
  ["管球", "light_tube"],
  ["粗大ごみ", "bulky_garbage"],    
  ["防犯カメラ", "security_camera"]   
]));

export function PropertyList() {
  return {
    propertyMapData
  }
};